import streamApi from "@/api/streamApi";

export default {
  state: {
    listVariables: [],
    lastProcess: {},
    evalVariables: [],
    makeReactive: false,
    attributes: [],
    currenteMachine: {}
  },
  getters: {
    getProcess: state => {
      if (state.makeReactive !== "undefined") {
        return state.lastProcess;
      }
    },
    getAllVariables: state => {
      if (state.makeReactive !== "undefined") {
        return state.listVariables;
      }
    },
    getAttributes: state => state.attributes
  },
  actions: {
    subscribe: ({ state, commit, rootGetters }) => {
      state.currenteMachine = rootGetters["Machine/getSelected"];
      const idForStreamApi = rootGetters["Machine/getSelected"].Id;
      let attributes = [];

      if (idForStreamApi) {
        // const m = rootGetters["Machine/getSelected"];
        // let family = "";

        // if (m.MachineFamily) {
        //   family = m.MachineFamily.toLowerCase();
        // }
        // // Check CMS
        // if (m.TicketManager && m.TicketManager === "CMS") {
        //   family = "cms";
        // }

        // switch (family) {
        //   // CMS
        //   case "cms":
        //   // SEZ
        //   case "beam_saw":
        //   case "sez":
        //   // FOR
        //   case "bor":
        //   case "boring":
        //   case "boring_machine":
        //   // BOR
        //   case "eba":
        //   case "edge_bander":
        //   // CDL
        //   case "cnc_machine":
        //   case "cdl":
        //   default:
        //     break;
        // }

        attributes = [
          {
            label: "Name",
            ch: "Machine/WorkingArea/Area_1/Program_1/Name",
            old: true
          },
          {
            label: "Process_Name",
            ch: "Name"
          },
          {
            label: "Program_Name",
            ch: "Programs/01/Name"
          },
          {
            label: "Consumable",
            ch: "Programs/01/Consumables/Name"
          }
          /*
          {
            label: "Consumable_Name",
            ch: "Programs/01/Consumables/02/Name"
          },
          {
            label: "Consumable_Type",
            ch: "Programs/01/Consumables/02/Type"
          }
          */
        ];

        state.evalVariables = [
          // New Data model
          {
            label: "Reps_Target",
            ch: "RepsTarget"
          },
          {
            label: "Reps_Programmed",
            ch: "RepsProgrammed"
          },
          {
            label: "Reps_Done",
            ch: "RepsDone"
          },
          {
            label: "OverlapNum",
            ch: "OverlapNum"
          },
          {
            label: "DimensionX",
            ch: "DimensionX"
          },
          {
            label: "DimensionY",
            ch: "DimensionY"
          },
          {
            label: "DimensionZ",
            ch: "DimensionZ"
          },
          {
            label: "End_Time",
            ch: "EndTime"
          },
          {
            label: "Pieces_Material",
            ch: "Pieces/Material"
          },
          {
            label: "Pieces_DimensionX",
            ch: "Pieces/DimensionX",
            udm: "mm"
          },
          {
            label: "Pieces_DimensionY",
            ch: "Pieces/DimensionY",
            udm: "mm"
          },
          {
            label: "Pieces_DimensionZ",
            ch: "Pieces/DimensionZ",
            udm: "mm"
          },
          {
            label: "Consumable_Name",
            ch: "Consumables/01/Name"
          },
          {
            label: "Consumable_Type",
            ch: "Consumables/01/Type"
          },
          {
            label: "Consumable",
            ch: "Consumables/01/Value"
          }
          /*{
            label: "Consumable",
            ch: "Consumables/02/Value"
          }*/
        ];

        // Subscribe variable
        state.evalVariables.forEach(variable => {
          if (!variable.old) {
            ["01", "02", "03", "04"].forEach(i => {
              const chComplete = `Machine/ProductionProcesses/${i}/Programs/01/${variable.ch}`;

              streamApi.subLatest(idForStreamApi, chComplete, function (pub) {
                if (state.currenteMachine.Device.Device_Id === pub.of) {
                  const last_val = pub.data.v !== undefined ? pub.data.v.toString() : "";
                  let current_val = "-";
                  // Check if value is Numeric or String
                  try {
                    if (isNaN(last_val.replace(",", ".").replace(" ", ""))) {
                      current_val = last_val;
                    } else if (last_val) {
                      current_val = Number(last_val.replace(",", ".").replace(" ", ""));
                    }
                  } catch (e) {
                    console.error("data.v is not defined");
                  }

                  commit("UPDATE_VARIABLE", {
                    data: {
                      label: variable.label,
                      value: current_val,
                      ts: pub.data.ts,
                      channel: pub.channel
                    },
                    ref: `${i}_01`
                  });

                  // Check attributes
                  try {
                    attributes.forEach(attribute => {
                      const channel = `Machine/ProductionProcesses/${i}/${attribute.ch}`;

                      streamApi.retrieveHistorical(
                        idForStreamApi,
                        channel,
                        { limit: 1 },
                        function (pubAttr) {
                          if (pubAttr.length > 0) {
                            commit("UPDATE_ATTRIBUTE", {
                              ref: `${i}_01`,
                              data: {
                                label: attribute.label,
                                value: pubAttr[0].data.v ? pubAttr[0].data.v : "-",
                                ts: pubAttr[0].data.ts
                              }
                            });
                          }
                        }
                      );
                    });
                  } catch (e) {
                    console.error(e);
                  }
                }
              });
            });
          }
          // Old Data Model
          else {
            streamApi.subLatest(idForStreamApi, variable.ch, function (pub) {
              if (state.currenteMachine.Device.Device_Id === pub.of) {
                const last_val = pub.data.v !== undefined ? pub.data.v.toString() : "";
                let current_val = "-";
                // Check if value is Numeric or String
                try {
                  if (isNaN(last_val.replace(",", ".").replace(" ", ""))) {
                    current_val = last_val;
                  } else if (last_val) {
                    current_val = Number(last_val.replace(",", ".").replace(" ", ""));
                  }
                } catch (e) {
                  console.error("data.v is not defined");
                }

                commit("UPDATE_VARIABLE", {
                  data: {
                    label: variable.label,
                    value: current_val,
                    ts: pub.data.ts,
                    channel: pub.channel
                  },
                  ref: `Area_01`
                });

                // Check attributes
                try {
                  const attribute = attributes.find(el => el.old === true);
                  if (attribute) {
                    streamApi.retrieveHistorical(
                      idForStreamApi,
                      attribute.ch,
                      { limit: 1 },
                      function (pubAttr) {
                        if (pubAttr.length > 0) {
                          commit("UPDATE_ATTRIBUTE", {
                            ref: `Area_01`,
                            data: {
                              label: attribute.label,
                              value: pubAttr[0].data.v ? pubAttr[0].data.v : "-",
                              ts: pubAttr[0].data.ts
                            }
                          });
                        }
                      }
                    );
                  }
                } catch (e) {
                  console.error(e);
                }
              }
            });
          }
        });
      }
    },

    unsubscribe: ({ state, commit, rootGetters }) => {
      state.listVariables.forEach(item => {
        item.data.forEach(variable => {
          streamApi.unsub(rootGetters["Machine/getSelected"].Id, variable.channel, function () {});
        });
      });
      commit("RESET");
    }
  },
  mutations: {
    UPDATE_ATTRIBUTE: (state, payload) => {
      const idx = state.attributes.findIndex(item => item.ref === payload.ref);
      if (idx > -1) {
        // Updtate
        const currentAttrValues = state.attributes[idx];
        const idxLabel = currentAttrValues.data.findIndex(
          attr => attr.label === payload.data.label
        );
        if (idxLabel > -1) {
          // Update
          Object.assign(currentAttrValues.data[idxLabel], payload.data);
        } else {
          // Add Variable
          currentAttrValues.data.push(payload.data);
        }
        Object.assign(state.attributes[idx], currentAttrValues);
      } else {
        const newAttr = {
          ref: payload.ref,
          data: [payload.data]
        };

        state.attributes.push(newAttr);
      }
    },
    UPDATE_VARIABLE: (state, payload) => {
      // Check list variables process
      const idx = state.listVariables.findIndex(item => item.ref === payload.ref);
      if (idx < 0) {
        state.listVariables.push({
          ref: payload.ref,
          data: [payload.data]
        });
      } else {
        // Update process
        const process = state.listVariables[idx];
        const idxLabel = process.data.findIndex(item => item.label === payload.data.label);
        if (idxLabel > -1) {
          Object.assign(process.data[idxLabel], payload.data);
        } else {
          // Add Variable
          process.data.push(payload.data);
        }
        Object.assign(state.listVariables[idx], process);
      }

      state.lastProcess = payload;
      state.makeReactive = !state.makeReactive;
    },

    RESET: state => {
      state.listVariables = [];
      state.evalVariables = [];
      state.lastProcess = {};
      state.attributes = [];
      state.makeReactive = !state.makeReactive;
    }
  },
  namespaced: true,
  modules: {}
};
